fetch('/rest/profiles/v1/current-user')
    .then((resp) => {
        if (resp.status === 200) {
            import('./index.react').then(() => {
                /*
                resp.json().then((data) => {
                    localStorage.setItem('current-user', JSON.stringify(data))
                })
                    */
            })
        }

        if (resp.status === 401) {
            const encodedUrl = encodeURIComponent(window.location.href)
            window.location.replace(`/web-auth/start?rd=${encodedUrl}`)
        }
    })
    .catch((err) => {
        /* eslint-disable no-console */
        console.error(err)
        const encodedUrl = encodeURIComponent(window.location.href)
        window.location.replace(`/web-auth/start?rd=${encodedUrl}`)
    })
